module.exports = __webpack_public_path__ + "img/c348b37.png";